export const RaffleTable = ({ Render }) => {
  return <Render />;
};
